// Définit la structure de l'objet créé par wp_localize_script()
interface IThemeData {
  lang: string;
  closeLabel: string;
  menuLabel: string;
}

// Déclare que cet objet existe sur l'objet Window global
declare global {
  interface Window {
    WP_THEME_DATA: IThemeData;
  }
}

export class HeaderManager {
  // Définition d'un objet de traduction par défaut avec les chaînes originales
  private readonly DEFAULT_TRANSLATIONS: IThemeData = {
    lang: 'fr', // Langue par défaut
    closeLabel: 'Fermer',
    menuLabel: 'Menu',
  };
  // Initialisation sécurisée : utilise WP_THEME_DATA si elle existe, sinon utilise les DEFAULTS
  private readonly TRANSLATIONS: IThemeData = window.WP_THEME_DATA || this.DEFAULT_TRANSLATIONS;

  private overlay: Element | null;
  private menuItems: NodeListOf<Element>;
  private currentTimeout: number | null = null;
  private subMenuItems: NodeListOf<Element>;
  private debounceTimeout: number | null = null;
  private readonly DEBOUNCE_DELAY = 300;

  constructor() {
    // console.log('🚀 ~ HeaderManager ~ TRANSLATIONS:', this.TRANSLATIONS);
    this.overlay = document.querySelector('.header-primary__overlay');
    this.menuItems = document.querySelectorAll('.header-primary__menu-item.has-submenu');
    this.subMenuItems = document.querySelectorAll('.header-primary__mobile-menu-item');
    this.init();
  }

  private init(): void {
    const burger = document.querySelector('.header-primary__burger-content');
    const menu = document.querySelector('.header-primary__menu-social');
    const mobileMenu = document.querySelector('.header-primary__mobile-menu');
    const header = document.querySelector('.header-primary__row');
    const btnLibelle = document.querySelector('.header-primary__burger-intitule')!;

    // Récupérer les libellés traduits
    const closeText = this.TRANSLATIONS.closeLabel;
    const menuText = this.TRANSLATIONS.menuLabel;

    burger?.addEventListener('click', function () {
      if (burger.classList.contains('header-primary__burger-button--active')) {
        burger.classList.remove('header-primary__burger-button--active');
        menu?.classList.remove('header-primary__menu-social--active');
        menu?.classList.add('header-primary__menu-social--inactive');
      } else {
        burger.classList.add('header-primary__burger-button--active');
        menu?.classList.add('header-primary__menu-social--active');
        menu?.classList.remove('header-primary__menu-social--inactive');
      }

      if (!mobileMenu?.classList.contains('header-primary__mobile-menu--active')) {
        mobileMenu?.classList.add('header-primary__mobile-menu--active');
        header?.classList.add('header-primary__row--active');
        btnLibelle.textContent = closeText;
      } else {
        mobileMenu?.classList.remove('header-primary__mobile-menu--active');
        header?.classList.remove('header-primary__row--active');
        btnLibelle.textContent = menuText;
      }
    });
    this.handleOverlay();

    this.subMenuItems.forEach(item => {
      item.addEventListener('click', ev => this.handleSubMenuClick(ev));
    });
  }

  private handleOverlay(): void {
    if (!this.overlay) return;

    this.menuItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        this.overlay?.classList.add('active');
      });

      item.addEventListener('mouseleave', () => {
        this.overlay?.classList.remove('active');
      });
    });
  }

  private async handleSubMenuClick(e: Event): Promise<void> {
    const menuItem = e.target as HTMLElement;
    const parent = menuItem.closest('.header-primary__mobile-menu-item');

    if (!parent?.classList.contains('active')) {
      parent?.classList.add('active');
    } else {
      parent?.classList.remove('active');
    }
  }
}

// Initialisation
document.addEventListener('DOMContentLoaded', () => {
  new HeaderManager();
});
